export default __webpack_public_path__ + "static/media/Noor.8fe162e6.jpg";